import { getStatusColor, PoOrder, OrderStatus } from "../utils";
import OrderCardCore, { formatDateForOrderCard } from "./OrderCardCore";
import styles from "./OrderCardCore.module.scss";

interface PoCardProps {
  order: PoOrder;
  status: OrderStatus;
  onViewClick: () => void;
}

const PoCard = ({ order, status, onViewClick }: PoCardProps) => (
  <OrderCardCore
    status={status}
    onViewClick={onViewClick}
    isAlwaysOpen
    title={
      <div className={styles.row}>
        PO: {order.id}
        <span
          className={styles.circle}
          style={{ backgroundColor: getStatusColor(status) }}
        ></span>
      </div>
    }
  >
    <div className={styles.amount}>
      <span className={styles.gray}>COGS: </span> £{order.cogs}
    </div>
    <div className={styles.amount}>
      <span className={styles.gray}>Order Date: </span>
      {formatDateForOrderCard(order.orderDate)}
    </div>
    <div className={styles.amount}>
      <span className={styles.gray}>Est.Сomp.Date: </span>
      {formatDateForOrderCard(order.estCompleteDate)}
    </div>
  </OrderCardCore>
);

export default PoCard;
